export default "__VITE_ASSET__CMY9JZCx__"